import { render, staticRenderFns } from "./paypalView.vue?vue&type=template&id=678fe8a8&"
import script from "./paypalView.vue?vue&type=script&lang=js&"
export * from "./paypalView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "paypalView.vue"
export default component.exports